// extracted by mini-css-extract-plugin
export var container = "MarkdownSection-module--container--34e7b";
export var root = "MarkdownSection-module--root--aa8f0";